import i18n from "../plugins/i18n";
export default function(str, fallbackStr) {
    if (fallbackStr === undefined) {
        fallbackStr = '';
    }
    // use `$te` and `$t
    return i18n.tc && i18n.te
        ? i18n.te(str)
            ? i18n.tc(str)
            : fallbackStr
        : fallbackStr
            ? fallbackStr
            : str
}
